import moment from 'moment'
import Vue from 'vue'
import Vuex from 'vuex'

import routeEventsApi from '@/api/route_events/index'
import { i18n } from '@/i18n'
import router from '@/router/index'

Vue.use(Vuex)

export const ActionTypes = {
  CHECK_ROUTE_STATUS: 'CHECK_ROUTE_STATUS',
  VERIFY_ROUTE_STATUS: 'VERIFY_ROUTE_STATUS',
}

export const MutationTypes = {
  CHECKING_ROUTE_STATUS: 'CHECKING_ROUTE_STATUS',
  DELETE_ROUTE_STATUS: 'DELETE_ROUTE_STATUS',
}

export const mutations = {
  [MutationTypes.CHECKING_ROUTE_STATUS](state, payload) {
    Vue.set(state.creatingRouteInfo, payload.eventUuid, {
      creating: ['creating', 'pending', 'calculated'].includes(payload.status),
      generatedAt: payload.generated_at,
      details: payload.details,
    })
  },
  [MutationTypes.DELETE_ROUTE_STATUS](state, payload) {
    Vue.delete(state.creatingRouteInfo, payload.eventUuid)
  },
}

export const getters = {
  creatingRouteInfo: state => {
    return state.creatingRouteInfo
  },
}

export const actions = {
  async [ActionTypes.CHECK_ROUTE_STATUS]({ commit, dispatch, getters }, payload) {
    const result = await routeEventsApi.getRouteStatus(payload.eventUuid)

    if (!result.success) return sendRouteNotify('error')

    if (['creating', 'pending', 'calculated', 'failed'].includes(result.data.status)) {
      if (minutesAgoFromDate(result.data.generated_at) > 70 || result.data.status == 'failed') {
        sendRouteNotify('error')
        return commit(MutationTypes.DELETE_ROUTE_STATUS, {
          eventUuid: payload.eventUuid,
        })
      }

      setTimeout(() => {
        dispatch('CHECK_ROUTE_STATUS', payload)
      }, 60000)

      return commit(MutationTypes.CHECKING_ROUTE_STATUS, {
        ...result.data,
        eventUuid: payload.eventUuid,
      })
    }

    // so it doesnt throw a notification when loading the route_event view
    if (payload.eventUuid in getters.creatingRouteInfo) {
      if (routeCreated(result.data.status)) {
        setTimeout(() => {
          dispatch('VERIFY_ROUTE_STATUS', payload)
        }, 10000)
      } else {
        sendRouteNotify('error', payload.details)
        commit(MutationTypes.DELETE_ROUTE_STATUS, {
          eventUuid: payload.eventUuid,
        })
      }
    }
  },
  async [ActionTypes.VERIFY_ROUTE_STATUS]({ commit }, payload) {
    const result = await routeEventsApi.getRouteStatus(payload.eventUuid)

    if (routeCreated(result.data.status)) {
      sendRouteNotify('success')
      // if the user is still in the create route view, then we refresh the page
      if (router.currentRoute?.name == 'route_event') {
        setTimeout(() => {
          router.go()
        }, 1000)
      }
    } else {
      sendRouteNotify('error', payload.details)
    }

    commit(MutationTypes.DELETE_ROUTE_STATUS, {
      eventUuid: payload.eventUuid,
    })
  },
}

export const storeConfig = {
  state() {
    return {
      creatingRouteInfo: {},
    }
  },
  mutations,
  getters,
  actions,
}

const sendRouteNotify = (notifyType, message) => {
  const defaultMessage = notifyType == 'error' ? i18n.t('meta.noSuccess') : i18n.t('routes.routeEvents.routeCreated')
  return Vue.notify({
    group: 'alert',
    type: notifyType,
    text: message || defaultMessage,
  })
}

const minutesAgoFromDate = datetime => {
  const now = moment(new Date())
  const duration = moment.duration(now.diff(moment(datetime)))
  return duration.asMinutes()
}

const routeCreated = status => ['success', 'available'].includes(status)

export default new Vuex.Store(storeConfig)
